import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../i18n/provider';
import styles from './AnonymousModeBanner.module.css';

const AnonymousModeBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated || location.pathname === '/login') {
    return null;
  }

  return (
    <div className={styles.banner} data-testid="anonymous-mode-banner">
      <div className={styles.content}>
        <p className={styles.title}>{t('shared.anonymousMode.title')}</p>
        <p className={styles.description}>
          {t('shared.anonymousMode.description')}
        </p>
      </div>
    </div>
  );
};

export default AnonymousModeBanner;